import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "./Staff.css";
import Nav from "../Nav/Nav";
import IntroStaff from "../IntroStaff/IntroStaff";
import Meet from "../MeetOurPeople/Meet";
import InviteStaff from "../InviteStaff/InviteStaff";
import LogoLoader from "../Loading/Loading";
import Footer from "../Footer/Footer";


const Staff = () => {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const targetId = searchParams.get("targetId") || location.state?.targetId;

  useEffect(() => {
      if (!isLoading && targetId) {
        const timeout = setTimeout(() => {
          const el = document.getElementById(targetId);
          if (el) {
            el.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }, 1500);
  
        return () => clearTimeout(timeout);
      }
    }, [isLoading, targetId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2650);

    return () => clearTimeout(timer);
  }, []);

  const [isAlbanian, setIsAlbanian] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage !== null ? JSON.parse(savedLanguage) : true;
  });

  const toggleLanguage = () => {
    setIsAlbanian((prev) => {
      const newLanguage = !prev;
      localStorage.setItem('language', JSON.stringify(newLanguage));
      return newLanguage;
    });
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <LogoLoader />
      </div>
    );
  }

  return (
    <>
    <div className="staffphoto-container-up">
      <Nav isAlbanian={isAlbanian} toggleLanguage={toggleLanguage} />
      <div className="staffphoto-container">
        <img src="/pamje.jpg" alt="staff-photo" className="staff-image" />
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="hero-title">
            <h1 className="overlay-text">
              {"  "}
              <strong>
                <span class="protest-font"></span>
                <img
                  src="/underlined2-1.png"
                  alt="Underline decoration"
                  className="underline-image"
                />
              </strong>{" "}
            </h1>
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
      <IntroStaff isAlbanian={isAlbanian} />
      <div id="meet">
        <Meet isAlbanian={isAlbanian} />
      </div>
      <InviteStaff isAlbanian={isAlbanian} />
    </div>
    <Footer isAlbanian={isAlbanian} />
    </>
  );
};

export default Staff;
